import { render, staticRenderFns } from "./EmployeeExpenses.vue?vue&type=template&id=4d8a4a69"
import script from "./EmployeeExpenses.vue?vue&type=script&lang=js"
export * from "./EmployeeExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports